export { default } from './components/nearby-homes-carousel';